import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=48062bde&scoped=true&"
import script from "./recharge.vue?vue&type=script&lang=js&"
export * from "./recharge.vue?vue&type=script&lang=js&"
import style0 from "./recharge.vue?vue&type=style&index=0&id=48062bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48062bde",
  null
  
)

export default component.exports